import {
    Service
  } from '../../../service.js'
  import {
    env
  } from '../../../env.js'
  import { toastUtils } from '../../../util/toast.utils.js';
  class GrupoDeTarefasService extends Service {

    constructor() {
      super()
      this.url = env.url + 'grupo-tarefas'
    }

    async buscarGrupoDeTarefas(id) {
      return super.get(this.url + `/${id}`)
    }

    async buscarGrupoDeTarefasPorIdDaTarefa(id) {
      return super.get(this.url + `/grupo-to-tarefa?tarefaId=`+id)
    }

    async listarGrupoDeTarefasComPaginacao(limit, pagina) {
      return super.get(this.url +
        `?sort%5BDESC%5D=id&limit=${limit}&pagina=${pagina}`)
    }

    async listarTarefaFiltro(nomeTarefa, limit, pagina) {
      return super.get(this.url +
        `?sort%5BDESC%5D=id&nome%5Bilike%5D=%25${nomeTarefa}%25&limit=${limit}&pagina=${pagina}`
      )
    }

    // TODO: Descacoplamento de service, o componente ja esta configurado para puxar o service de tarefas na
    // montagem do objeto de select (ECT-329). Precisamos validar se esse metodo ainda é utilizado, substituir
    // sua aplicação e remover do escopo do grupo.

    async listarTarefas() {
      const tarefas = await super.get(`${env.url}tarefas`);
      const total = tarefas.totalDeItens
      const tarefas_data = await super.get(`${env.url}tarefas?limit=${total}`)
      return tarefas_data.data.map((element) => {
        return {
          value: element.id,
          label: element.nome
        };
      })
    }

    async delete(item) {
      return await super.delete(this.url, item)
    }

    async post(item) {
      const response = await super.post(this.url, item);
      const responseJson = await response.json();
      if (response.status === 201) {
        this.adicionarVinculacaoAoPoolling(responseJson,responseJson.uuid);
      } else if (responseJson.message) {
        throw new Error(responseJson.message);
      }
    }

    async editarGrupoDeTarefas(item) {
      const response = await super.patch(this.url, item);
      const responseJson = await response.json();
      if (!!!item.dataVigencia) {
        if (response.status === 200) {
          toastUtils.successToast("Grupo de tarefas editado com sucesso!");
          setTimeout(() => {
            window.location.reload(true)
          }, 3000);
        } else if (responseJson.message) {
          throw new Error(responseJson.message);
        } else {
          throw new Error('HTTP ' + response.status);
        }
      } else {
        this.adicionarAoPoolling(item,responseJson,responseJson.uuid);
      }
    }

    async adicionarAoPoolling(item,responseJson,uuid) {
      const { poollingStore } = await import('../../../stateManagement/poolling.js');

      const objetoGupoTarefas = {
        uuid: uuid,
        modulo: 'grupo-tarefas'
      }

      if (item.inseriuTarefas || (item.edicaoDeTarefasDesativada && (item.inseriuEmpresas || item.removeuEmpresas))) {
        objetoGupoTarefas.modulo = 'grupo-tarefas'
      }

      if (item.removeuTarefas && !item.edicaoDeTarefasDesativada) {
        objetoGupoTarefas.modulo = 'grupo-tarefas-exclusao'
      }

      if (item.inseriuTarefas && item.removeuTarefas && !item.edicaoDeTarefasDesativada) {
        objetoGupoTarefas.modulo = 'grupo-tarefas-inclusao-exclusao'
      }

      poollingStore.AddRequestPendente(objetoGupoTarefas);
    }

    async adicionarVinculacaoAoPoolling(responseJson,uuid) {
      // if (!responseJson || !responseJson.status) return;

      const { poollingStore } = await import('../../../stateManagement/poolling.js');

      const objetoGupoTarefas = {
        uuid: uuid,
        modulo: 'grupo-tarefas'
      }

      poollingStore.AddRequestPendente(objetoGupoTarefas);
    }


    async adquirirStatusVinculacoes(uuid) {
      const response = await super.get(`${this.url}/execucoes/${uuid}`);
      return response;
    }

  }

  export const service = new GrupoDeTarefasService()
